import React, { useState, useEffect, useMemo } from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';

import lang from '../../constants/Languages.js';
import numberWithSpaces from '../../scripts/NumberWithSpaces.js';

//import img
import chevronDownAccent from '../../assets/icons/chevron-down-accent.svg';
import chevronDownContrast from '../../assets/icons/chevron-down-contrast.svg';
import chevronUpAccent from '../../assets/icons/chevron-up-accent.svg';
import chevronUpContrast from '../../assets/icons/chevron-up-contrast.svg';
// import mailAccent from '../../assets/icons/mail-accent.svg';
// import mailContrast from '../../assets/icons/mail-contrast.svg';

const StrucutreListItemContent = ({ 
    id, 
    childrenIds,
    label, 
    shortDescription, 
    recordsNumber,
    clang, 
    setStructureListHeight
}) => {
    const [isOpened, setIsOpened] = useState(false);

    const toggleOpened = () => {
        setStructureListHeight();
        setIsOpened(prevIsOpened => !prevIsOpened);
    };

    const link = useMemo(() => {
        /*if (childrenIds && childrenIds.length > 0) {
            return [id, ...childrenIds].map((childId, index) => `HEADINGS[${index}]=${childId}`).join('&');
        }*/
        return `HEADINGS[0]=${id}`;
    }, [id, childrenIds]);

    return (
        <div className="structure__list-item__content">
            <div className="structure__list-item__content--main">
                <div className="structure__label-container">
                    <Link 
                        to={`/headings/about/details?q=*&area=all&${link}`}
                        className="structure__label" 
                        title={label}
                    >
                        <strong>{label}</strong>
                    </Link>
                    
                    <div className="structure__count">
                        ({numberWithSpaces(!!recordsNumber ? recordsNumber : 0)})
                    </div>
                </div>
                { shortDescription && (
                    <div className="structure__info">
                        { !isOpened && (
                            <button 
                                className="structure__info__button" 
                                title={lang[clang].characteristics.field_desc} 
                                onClick={toggleOpened}
                            >
                                {lang[clang].characteristics.field_desc}
                                <img className="structure__info__button-img" src={chevronDownAccent} alt="" />
                                <img className="structure__info__button-img contrast" src={chevronDownContrast} alt="" />
                            </button>
                        )}
                        { isOpened && (
                            <button 
                                className="structure__info__button--opened" 
                                title={lang[clang].characteristics.field_desc} 
                                onClick={toggleOpened}
                            >
                                {lang[clang].characteristics.field_desc}
                                <img className="structure__info__button-img" src={chevronUpAccent} alt="" />
                                <img className="structure__info__button-img contrast" src={chevronUpContrast} alt="" />
                            </button>
                        )}
                        {/* {contact && (
                            <a href={`mailto:${contact}`} className="structure__info__button" title={lang[clang].characteristics.contact}>
                                {lang[clang].characteristics.contact}
                                <img className="structure__info__button-img--contact" src={mailAccent} alt="" />
                                <img className="structure__info__button-img--contact contrast" src={mailContrast} alt="" />
                            </a>
                            )} */}
                    </div>
                )}
            </div>
            {(isOpened && shortDescription) && (
                <div 
                    className="structure__info__desc" 
                    dangerouslySetInnerHTML={{__html: shortDescription}}
                />
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(StrucutreListItemContent));



// WEBPACK FOOTER //
// ./src/components/characteristics/StrucutreListItemContent.js